import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import ADULTOS_MAYORES from "../../../assets/img/ADULTOS_MAYORES.jpg";
import IndustryBannerBgSection from "./../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import RegularIconText from "./../../Atoms/RegularIconText/RegularIconText";
import MY_TRACKER_ICON_1 from "../../../assets/img/MY_TRACKER_ICON_1.svg";
import MY_TRACKER_ICON_2 from "../../../assets/img/MY_TRACKER_ICON_1.svg";
import MY_TRACKER_ICON_4 from "../../../assets/img/MY_TRACKER_ICON_4.svg";
import MY_TRACKER_ICON_5 from "../../../assets/img/MY_TRACKER_ICON_4.svg";
import GPS_PORTATIL from "../../../assets/img/GPS_PORTATIL.png";
import "./FamilyAdultosMayores.scss";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const FamilyAdultosMayores = () => {
	const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

	return (
		<>
			<ChangeableHeaderV2
				withTitle
				appearSecondNavbar={dropdownHeader} 
				titleBanner={content[language].header_title}
				spanTitleYellow={content[language].header_span_title}
				route="flota-marina"
			/>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].adultos_yellow_title}
					boldText={content[language].adultos_bold_title}
				/>
			</div>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{
						img: ADULTOS_MAYORES,
						alt: "Tablet con Graficos en Pantalla",
					}}
					imgRadius
					boldText={content[language].adultos_bold_text}
					paragraphs={content[language].adultos_text}
				/>
			</div>

			<IndustryBannerBgSection route="adultos-mayores">
				<h5 className="t5 center-text c-yellow yellow-line both-sides familyAdultosMayores-banner-content-title">
					{content[language].beneficios_yellow_title}
				</h5>
				<div className="familyAdultosMayores-banner-content-container">
					<div className="familyAdultosMayores-banner-content-component-container">
						<RegularIconText
							icon={MY_TRACKER_ICON_1}
							boldText={content[language].beneficio_1}
							width="100%"
							whiteText
							adultosMayoresCase
						/>
					</div>
					<div className="familyAdultosMayores-banner-content-component-container">
						<RegularIconText
							icon={MY_TRACKER_ICON_2}
							boldText={content[language].beneficio_2}
							width="100%"
							whiteText
							adultosMayoresCase
						/>
					</div>
					<div className="familyAdultosMayores-banner-content-component-container">
						<RegularIconText
							icon={MY_TRACKER_ICON_4}
							boldText={content[language].beneficio_3}
							width="100%"
							whiteText
							adultosMayoresCase
						/>
					</div>
					<div className="familyAdultosMayores-banner-content-component-container">
						<RegularIconText
							icon={MY_TRACKER_ICON_5}
							boldText={content[language].beneficio_4}
							width="100%"
							whiteText
							adultosMayoresCase
						/>
					</div>
				</div>
			</IndustryBannerBgSection>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					switchOrder
					yellowText={content[language].caracteristicas_yellow_title}
					checkText={content[language].caracteristicas_list}
					image={{
						img: GPS_PORTATIL,
						alt: "GPS_PORTATIL",
					}}
					imgRadius
				/>
			</div>
		</>
	);
};

export default FamilyAdultosMayores;
